import styles from './resumeModal.module.scss';
import Button from '../../button/Button';

type Props = {
  onClose?: () => void;
  onContinue: () => void;
  onStart: () => void;
};

function ResumeModal(props: Props) {
  const { onContinue, onStart } = props;
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>This Lesson is in Progress.</div>
        <div className={styles.subtitle}>Would you like to:</div>
        <div className={styles.btnWrapper}>
          <Button size={'small'} onClick={onStart} outline={true} className={styles.start} label={'Start from Beginning'}/>
          <Button size={'small'} onClick={onContinue} className={styles.resume} label={'Resume Lesson'}/>
        </div>
        {/* <Button size={'small'} onClick={onClose} outline={true} className={styles.returnButton} label={'Return to Unit'}/> */}
      </div>
    </div>
  );
}

export default ResumeModal;
